<div class="dropdown custom-dropdown" [class.show]="open">

    <!-- Campo principal -->
    <button class="form-control text-left dropdown-toggle" (click)="toggle()">
        {{ labelSelecionado }}
    </button>

    <!-- Painel -->
    <div class="dropdown-menu w-100 p-2" [class.show]="open">

        <!-- Busca -->
        <input type="text" class="form-control mb-2" placeholder="Procurar" (keyup)="filtrar($event)" />

        <!-- Selecionados -->
        <div class="selected-container mt-4" *ngIf="selectedItems.length">

            <strong>Selecionados ({{selectedItems.length}})</strong>

            <div class="selected-list mt-2">

                <div class="selected-item" *ngFor="let item of selectedItems">

                    {{ item.nome }}

                    <i class="fa fa-times remove" (click)="remove(item, $event)">
                    </i>

                </div>

            </div>

        </div>

        <div class="mt-2" *ngIf="loading">

            <div class="spinner-border spinner-border-sm text-primary" role="status">
            </div>
          
            <span class="ml-2">Carregando...</span>
          
        </div>

        <!-- Lista -->
        <div class="hierarchy-list" *ngIf="!loading">

            <div *ngFor="let pessoa of pessoas" class="hierarchy-item">

                <!-- Pessoa -->
                <div class="d-flex align-items-center mr-3">
                    <span (click)="togglePessoa(pessoa)">
                        <i class="fa" [ngClass]="pessoa.expanded ? 'fa-chevron-down' : 'fa-chevron-right'">
                        </i>
                    </span>
                    <app-node-checkbox [item]="pessoa" (changed)="select($event)">
                    </app-node-checkbox>
                </div>

                <!-- Categorias -->
                <div *ngIf="pessoa.expanded" class="ml-3">
                    <div class="ml-3 mr-3 mt-2" *ngIf="pessoa.hasFiliais">
                        <span (click)="toggleFiliais(pessoa)">
                            <i class="fa" [ngClass]="pessoa.expandedFiliais ? 'fa-chevron-down' : 'fa-chevron-right'">
                            </i>
                        </span>
                        Filiais
                        <div *ngIf="pessoa.expandedFiliais">
                            <div class="mt-2" *ngIf="!pessoa.filiais || pessoa.filiais.length == 0">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                </div>                                                                                          
                            </div>
                            <div *ngFor="let filial of pessoa.filiais" class="hierarchy-item">
                                <app-node-checkbox [item]="filial" (changed)="selectFilial($event)">
                                </app-node-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="ml-3 mr-3 mt-2" *ngIf="pessoa.hasOrgaosPublicos">
                        <span (click)="toggleOrgaosPublicos(pessoa)">
                            <i class="fa"
                                [ngClass]="pessoa.expandedOrgaosPublicos ? 'fa-chevron-down' : 'fa-chevron-right'">
                            </i>
                        </span>
                        Órgãos Públicos
                        <div *ngIf="pessoa.expandedOrgaosPublicos">
                            <div class="mt-2" *ngIf="!pessoa.orgaosPublicos || pessoa.orgaosPublicos.length == 0">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                </div>                                                                                          
                            </div>
                            <div *ngFor="let orgaoPublico of pessoa.orgaosPublicos" class="hierarchy-item">
                                <app-node-checkbox [item]="orgaoPublico" (changed)="selectOrgaosPublicos($event)">
                                </app-node-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="ml-3 mr-3 mt-2" *ngIf="pessoa.hasUnidadeDeNegocio">
                        <span (click)="toggleUnidadeDeNegocio(pessoa)">
                            <i class="fa"
                                [ngClass]="pessoa.expandedUnidadeDeNegocio ? 'fa-chevron-down' : 'fa-chevron-right'">
                            </i>
                        </span>
                        Unidade de Negócio
                        <div *ngIf="pessoa.expandedUnidadeDeNegocio">
                            <div class="mt-2" *ngIf="!pessoa.UnidadeDeNegocio || pessoa.UnidadeDeNegocio.length == 0">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                </div>                                                                                          
                            </div>
                            <div *ngFor="let unidadeDeNegocio of pessoa.unidadeDeNegocio" class="hierarchy-item">
                                <app-node-checkbox [item]="unidadeDeNegocio" (changed)="selectUnidadeDeNegocio($event)">
                                </app-node-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>